import { render, staticRenderFns } from "./OnlineConsultation.vue?vue&type=template&id=cec34614&scoped=true&"
import script from "./OnlineConsultation.vue?vue&type=script&lang=js&"
export * from "./OnlineConsultation.vue?vue&type=script&lang=js&"
import style0 from "./OnlineConsultation.vue?vue&type=style&index=0&id=cec34614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec34614",
  null
  
)

export default component.exports